import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMusic } from '@fortawesome/free-solid-svg-icons';
import { plural, formatBytes } from '../utils';
import { useEscapeKey } from '../hooks/useEscapeKey';

// Shown when a batch upload would exceed the user's storage plan. Lists only
// the files that don't fit (greedy partition) and lets the user upload the
// rest. When nothing fits, the confirm button is disabled — cancel only.
const StorageLimitModal = ({ rejected, acceptedCount, overBytes, onConfirm, onCancel }) => {
    useEscapeKey(onCancel);

    return (
        <div className="modal-backdrop" onClick={onCancel}>
            <div className="modal-card storage-limit-card" onClick={(e) => e.stopPropagation()}>
                <div className="new-project-eyebrow">STORAGE LIMIT</div>
                <div className="new-project-title">
                    {plural(rejected.length, 'file')} won’t fit your plan
                </div>
                <div className="delete-project-warning">
                    Uploading everything would put you {formatBytes(overBytes)} over your storage
                    limit.{' '}
                    {acceptedCount > 0
                        ? `The ${plural(acceptedCount, 'file')} that fit can still upload now.`
                        : 'Free up space or upgrade your plan to upload these.'}
                </div>
                <div className="storage-limit-sub">Won’t upload</div>
                <ul className="folder-drop-list">
                    {rejected.map((file, i) => (
                        <li key={i} className="folder-drop-list-row">
                            <FontAwesomeIcon icon={faMusic} className="folder-drop-list-icon" />
                            <span className="folder-drop-list-name">{file.name}</span>
                            <span className="folder-drop-list-count">{formatBytes(file.size)}</span>
                        </li>
                    ))}
                </ul>
                <div className="new-project-actions">
                    <button type="button" className="btn-ghost" onClick={onCancel}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn-primary"
                        onClick={onConfirm}
                        disabled={acceptedCount === 0}
                    >
                        {acceptedCount > 0 ? `Upload ${plural(acceptedCount, 'file')}` : 'Nothing fits'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StorageLimitModal;
